import { render, staticRenderFns } from "./volumeset.vue?vue&type=template&id=6886a923&scoped=true&"
import script from "./volumeset.vue?vue&type=script&lang=js&"
export * from "./volumeset.vue?vue&type=script&lang=js&"
import style0 from "./volumeset.vue?vue&type=style&index=0&id=6886a923&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6886a923",
  null
  
)

export default component.exports